/**
 * Medbook
 * Medbook api
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ReportSubTypeEnum } from './reportSubTypeEnum';
import { ReportTypeEnum } from './reportTypeEnum';
import { PickReportId } from './pickReportId';


/**
 * 
 */
export interface PartialReportBatch { 
    /**
     * 
     */
    id?: string;
    type?: ReportTypeEnum;
    subType?: ReportSubTypeEnum;
    /**
     * 
     */
    reportQueryId?: string;
    /**
     * 
     */
    endDate?: string;
    /**
     * 
     */
    startDate?: string;
    /**
     * 
     */
    generateStatus?: PartialReportBatch.GenerateStatusEnum;
    /**
     * 
     */
    total?: number;
    /**
     * 
     */
    generated?: number;
    /**
     * 
     */
    publishedTS?: string;
    /**
     * 
     */
    publishedSubscriptionId?: number;
    /**
     * 
     */
    publishedUserName?: string;
    /**
     * 
     */
    createTS?: string;
    /**
     * 
     */
    createSubscriptionId?: number;
    /**
     * 
     */
    createUserName?: string;
    /**
     * 
     */
    reports?: Array<PickReportId>;
}
export namespace PartialReportBatch {
    export type GenerateStatusEnum = 'done' | 'in-progress' | 'paused';
    export const GenerateStatusEnum = {
        Done: 'done' as GenerateStatusEnum,
        InProgress: 'in-progress' as GenerateStatusEnum,
        Paused: 'paused' as GenerateStatusEnum
    };
}


